

      document.addEventListener('DOMContentLoaded', function () {
        const observer = new MutationObserver((mutations) => {
          const formEmbed = document.querySelector('shopify-forms-embed');
          if (formEmbed?.shadowRoot) {
            // Inject our style rules
            if (!formEmbed.shadowRoot.querySelector('style[label-focus-styles]')) {
              const styleElement = document.createElement('style');
              styleElement.setAttribute('label-focus-styles', '');
              styleElement.textContent = `
            ._formFieldContainer_1mxsl_5:focus-within ._formInputFieldLabel_1mxsl_38 {
              display: none !important;
            }
           `;
              formEmbed.shadowRoot.appendChild(styleElement);
            }

            // Set up event listeners for all inputs
            const containers = formEmbed.shadowRoot.querySelectorAll('._formFieldContainer_1mxsl_5');
            containers.forEach((container) => {
              const input = container.querySelector('input, textarea');
              const label = container.querySelector('._formInputFieldLabel_1mxsl_38');

              if (input && label) {
                // Initial state check
                if (input.value) label.style.display = 'none';

                // Focus events
                input.addEventListener('focus', () => {
                  label.style.display = 'none';
                });

                // Blur events
                input.addEventListener('blur', () => {
                  if (!input.value) label.style.display = '';
                });

                // Input events (for dynamic changes)
                input.addEventListener('input', () => {
                  if (input.value) label.style.display = 'none';
                  else if (!input.matches(':focus')) label.style.display = '';
                });
              }
            });

            // Disconnect observer after setup
            observer.disconnect();
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      });

      document.addEventListener('DOMContentLoaded', function () {
        console.log('[Product URL Script] Initializing...');

        // Configuration
        const MAX_RETRIES = 8;
        const RETRY_DELAYS = [300, 500, 800, 1000, 1500, 2000, 3000, 5000];
        let retryCount = 0;
        let observer;
        let intervalId;

        // Main function to find and populate the textarea
        function populateProductUrl() {
          const currentUrl = window.location.href;
          console.log(`[Product URL Script] Current URL: ${currentUrl}`);

          // Enhanced shadow DOM search with event triggering
          function searchAndPopulate(root = document, depth = 0) {
            console.groupCollapsed(`[Product URL Script] Searching depth ${depth}`);

            try {
              // Search for textarea
              const textarea = root.querySelector('textarea[name="custom#product_url"]');

              if (textarea) {
                console.log('[Product URL Script] Found target textarea:', textarea);

                // Set the value
                textarea.value = currentUrl;

                // Remove required attribute if it exists
                textarea.removeAttribute('required');

                // Trigger all necessary events
                const events = ['input', 'change', 'blur'];
                events.forEach((eventType) => {
                  textarea.dispatchEvent(
                    new Event(eventType, {
                      bubbles: true,
                      cancelable: true,
                    })
                  );
                });

                // Force form validation update
                setTimeout(() => {
                  if (textarea.reportValidity) {
                    textarea.reportValidity();
                  }

                  const form = textarea.closest('form');
                  if (form && form.reportValidity) {
                    form.reportValidity();
                  }
                }, 100);

                console.log('[Product URL Script] Value set and events triggered');
                console.groupEnd();
                return true;
              }

              // Search in shadow roots
              const shadowRoots = Array.from(root.querySelectorAll('*'))
                .filter((el) => el.shadowRoot)
                .map((el) => el.shadowRoot);

              console.log(`[Product URL Script] Found ${shadowRoots.length} shadow roots at depth ${depth}`);

              for (const shadowRoot of shadowRoots) {
                if (searchAndPopulate(shadowRoot, depth + 1)) {
                  console.groupEnd();
                  return true;
                }
              }
            } catch (error) {
              console.error('[Product URL Script] Error during search:', error);
            }

            console.groupEnd();
            return false;
          }

          // Attempt population
          if (searchAndPopulate()) {
            console.log('[Product URL Script] Successfully populated field');
            cleanup();
            return;
          }

          // Schedule retries if needed
          if (retryCount < MAX_RETRIES) {
            const delay = RETRY_DELAYS[retryCount] || 5000;
            console.log(`[Product URL Script] Scheduling retry #${retryCount + 1} in ${delay}ms`);

            setTimeout(() => {
              retryCount++;
              console.log(`[Product URL Script] Executing retry #${retryCount}`);
              populateProductUrl();
            }, delay);
          } else {
            console.warn('[Product URL Script] Max retries reached - giving up');
            cleanup();
          }
        }

        // MutationObserver callback
        function handleMutations(mutationsList) {
          console.log('[Product URL Script] DOM mutation detected');
          for (const mutation of mutationsList) {
            if (mutation.addedNodes.length > 0) {
              console.log(`[Product URL Script] ${mutation.addedNodes.length} nodes added`);
              populateProductUrl();
              break;
            }
          }
        }

        // Cleanup function
        function cleanup() {
          if (observer) {
            observer.disconnect();
            console.log('[Product URL Script] MutationObserver disconnected');
          }
          if (intervalId) {
            clearInterval(intervalId);
            console.log('[Product URL Script] Interval cleared');
          }
        }

        // Initialize MutationObserver
        observer = new MutationObserver(handleMutations);
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: false,
          characterData: false,
        });
        console.log('[Product URL Script] MutationObserver initialized');

        // Periodic check as fallback
        intervalId = setInterval(() => {
          if (retryCount >= MAX_RETRIES) {
            cleanup();
            return;
          }
          console.log('[Product URL Script] Periodic check running');
          populateProductUrl();
        }, 10000);

        // Initial execution
        console.log('[Product URL Script] Starting initial population attempt');
        populateProductUrl();

        // Cleanup on page unload
        window.addEventListener('beforeunload', cleanup);
      });

      document.addEventListener('DOMContentLoaded', function () {
        let styled = false;

        function styleFormElements() {
          if (styled) return;

          const formEmbed = document.querySelector('shopify-forms-embed');
          if (!formEmbed?.shadowRoot) return;

          const shadowRoot = formEmbed.shadowRoot;

          // Create a single style element with all your styles
          if (!shadowRoot.querySelector('style[custom-styles]')) {
            const styleElement = document.createElement('style');
            styleElement.setAttribute('custom-styles', '');
            styleElement.textContent = `
        /* Button Styles */
        button[data-testid="btn-form-submit"] {
          display: flex !important;
          height: 50px !important;
          padding: 0 24px !important;
          justify-content: center !important;
          align-items: center !important;
          gap: 10px !important;
          background: var(--Main, #273462) !important;
          color: var(--White, #FFF) !important;
          font-family: Poppins !important;
          font-size: 14px !important;
          font-style: normal !important;
          font-weight: 500 !important;
          line-height: normal !important;
          text-transform: uppercase !important;
          border: none !important;
          cursor: pointer !important;
          border-radius: 0 !important;
        }
        
        button[data-testid="btn-form-submit"]:hover {
          opacity: 0.9 !important;
        }
        
        /* Heading Styles */
        ._textHeading_2aowh_35 {
          color: var(--Main, #273462) !important;
          font-family: ModernoFB !important;
          font-size: 30px !important;
          font-style: normal !important;
          font-weight: 400 !important;
          line-height: 110% !important;
          letter-spacing: 0.4px !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        
        /* Remove the problematic focus styles */
        ._formFieldContainer_1mxsl_5:focus-within ._formInputFieldLabel_1mxsl_38 {
          /* Remove display: none to prevent hiding issues */
        }
      `;

            shadowRoot.appendChild(styleElement);
            styled = true;
            console.log('Form styles applied successfully');
          }
        }

        // Try to style immediately
        styleFormElements();

        // Also try after a short delay when shadow DOM might be ready
        setTimeout(styleFormElements, 100);

        // Watch for form appearance
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
              styleFormElements();
            }
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        });
      });
  